/** Entry point: set Cesium's asset base before anything imports it, then boot the app. */

import './styles.css';
import { App } from './app';

declare global {
  interface Window {
    CESIUM_BASE_URL?: string;
  }
}

// Cesium resolves Workers, Assets and Widgets against this at runtime. vite.config.ts copies
// them to dist/cesium; `base: './'` keeps the app deployable under a sub-path.
window.CESIUM_BASE_URL = new URL('cesium/', document.baseURI).href;

const app = new App();
// Dev-only handle for smoke tests and console debugging; stripped from the production mental
// model (import.meta.env.DEV is false in builds, so the global is never set there).
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).__phasmaApp = app;
}
app.start().catch((error: unknown) => {
  console.error(error);
  const host = document.getElementById('status');
  if (host) {
    const el = document.createElement('div');
    el.className = 'toast';
    el.dataset.kind = 'error';
    el.textContent = `Startup failed: ${error instanceof Error ? error.message : String(error)}`;
    host.appendChild(el);
  }
});
